import { render, staticRenderFns } from "./inputContractAmount.vue?vue&type=template&id=31c3c447"
import script from "./inputContractAmount.vue?vue&type=script&lang=js"
export * from "./inputContractAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports